'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _express = require('express');

var _minimajs = require('minimajs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The handler template.
 * 
 * @export
 * @class VersionRestHandler
 */
var VersionRestHandler = function () {
    /**
     * Creates an instance of VersionRestHandler.
     * 
     * @param {Plugin} plugin 
     * @memberof VersionRestHandler
     */
    function VersionRestHandler(plugin) {
        (0, _classCallCheck3.default)(this, VersionRestHandler);

        this.plugin = plugin;

        this.handle = this.handle.bind(this);
    }

    /**
     * Handle a REST request: http://locahost:3000/demoPlugin/version
     * 
     * @param {Request} request 
     * @param {Response} response 
     * @memberof VersionRestHandler
     */


    (0, _createClass3.default)(VersionRestHandler, [{
        key: 'handle',
        value: function handle(request, response) {
            response.json({ "version": this.plugin.version.versionString });
        }
    }]);
    return VersionRestHandler;
}();

exports.default = VersionRestHandler;
//# sourceMappingURL=VersionRestHandler.js.map